import PropTypes from "prop-types"
import React from "react"
import { richTextToHtml } from "utils/richTextToHtml"

function RichTextContent({ className, children }) {
  if (children?.raw) {
    const richText = JSON.parse(children?.raw)
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{
          __html: richTextToHtml(richText).replace(/\n/g, `<br />`),
        }}
      />
    )
  }
  return null
}

RichTextContent.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** Rich text with "raw" attribute */
  children: PropTypes.shape({
    raw: PropTypes.string,
  }),
}

export default RichTextContent
